<template>
  <div class="compressed-content">
    <h3 class="page-question">On your last ankle brachial index, did you have a low blood pressure ratio (&lt;0.9) when your arm and ankle blood pressures were measured?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadLowPressureRatio">
      <b-form-radio v-model="survey.arteryBlockages.lastAnkleBrachialTest.hadLowPressureRatio" name="ratio" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.arteryBlockages.lastAnkleBrachialTest.hadLowPressureRatio" name="ratio" :value="false">No</b-form-radio>
    </v-form-group>
    <h3 class="mt-5 page-question">Was this reported to you as “low”?</h3>
    <b-form-group class="card-selector page-buttons">
      <b-form-radio v-model="survey.arteryBlockages.lastAnkleBrachialTest.reportedLowPressure" name="low" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.arteryBlockages.lastAnkleBrachialTest.reportedLowPressure" name="low" :value="false">No</b-form-radio>
    </b-form-group>
    <h3 class="mb-3 page-question">How old were you when you had this test completed?</h3>
    <v-form-group class="page-buttons" :validator="$v.age" label="Age">
      <b-form-input slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="survey.arteryBlockages.lastAnkleBrachialTest.doneAtAge"
                    placeholder="18 - 90" />
    </v-form-group>
    <h3 class="mt-5 page-question">Did your test show a LOWER ABI value than any previous assessments?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.isProgression">
      <b-form-radio v-model="survey.arteryBlockages.lastAnkleBrachialTest.isProgression" name="progress" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.arteryBlockages.lastAnkleBrachialTest.isProgression" name="progress" :value="false">No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between, numeric } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      hadLowPressureRatio: {
        required
      },
      age: {
        required,
        between: between(18, 90),
        numeric
      },
      isProgression: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hadLowPressureRatio() { return this.survey.arteryBlockages.lastAnkleBrachialTest.hadLowPressureRatio; },
      age() { return this.survey.arteryBlockages.lastAnkleBrachialTest.doneAtAge; },
      isProgression() { return this.survey.arteryBlockages.lastAnkleBrachialTest.isProgression; }
    }
  };
</script>